<template lang="pug">
  div
    v-card(
      class="mb-12" height="auto")
      v-layout(row wrap)
        v-flex(xs12 sm12) 
            h3(class="headerSection") Klasifikasi Umum Perubahan
            br 
        v-flex
            div(style="margin: 0 0 0 30px;padding: 0;")
                v-layout(row wrap)
                    v-flex(
                      xs10 
                      sm3 
                      v-for="(item, index) in dataSubmitPerubahan.ipKlasifikasiUmum" 
                      :key="index"
                    )
                        v-checkbox(
                          class="locationOptions" 
                          v-model="item.selected" 
                          :label="item.label"
                        )

        v-flex(xs12 sm12) 
            h3(class="headerSection" style="margin-top:10px") Rincian Usulan Perubahan
            br
        v-flex
            div(style="margin: 0 0 0 30px;padding: 0;")
                v-layout(row wrap v-for="(item, index) in dataSubmitPerubahan.ipRincianUsulan" :key="index")
                    v-flex(xs10 sm4 )
                        v-checkbox(
                          class="locationOptions" 
                          v-model="item.selected"  
                          :label="item.label"
                          @change="handleSelectChange(item)"
                        )
                    v-flex(
                      xs10 
                      sm7 
                      style="margin-top:-25px;margin-bottom:8px"
                    )
                        v-text-field(
                          label="Tuliskan" 
                          style="margin:1px" 
                          v-model="item.description" 
                          :disabled="!item.selected"
                        )        
        v-flex(xs12 sm12) 
            h3(class="headerSection" style="margin-top:10px") Hasil Yang Diharapkan
            br
        v-flex
            div(style="margin: 0 0 0 30px;padding: 0;")
                v-layout(
                  row 
                  wrap 
                  v-for="(item, index) in dataSubmitPerubahan.ipHasilHarapan" 
                  :key="index"
                )
                    v-flex(xs10 sm4)
                        v-checkbox(
                          class="locationOptions"  
                          v-model="item.selected"  
                          :label="item.label"
                          @change="handleSelectChange(item)"
                        )
                    v-flex(
                      xs10 
                      sm7 
                      style="margin-top:-25px;margin-bottom:8px"
                    )
                        v-text-field(
                          label="Tuliskan" 
                          style="margin:1px" 
                          v-model="item.description" 
                          :disabled="!item.selected"
                        )
        v-flex(xs12 sm12) 
            h3(class="headerSection") Deskripsi Hasil yang Diharapkan
            br
        v-flex( sm12)
            div(style="margin: 0 15px 35px 15px;padding: 0;")
                ckeditor(:editor="editor" v-model="dataSubmitPerubahan.ipHasilDescription" :config="editorConfig")
        
        v-flex(xs5 sm2) 
            h3(class="headerSection") Lampiran
        v-flex(
          xs6 
          sm4 
          class="attachment" 
          v-if="!dataSubmitPerubahan.ipHasilDescriptionUploadId && ( !docPendukungRincian || docPendukungRincian.size > 10000000 )"
        )
            v-file-input( 
              :rules="rules"  
              label="Hanya 1 file, max 10MB" 
              v-model="docPendukungRincian"
            )
                template(
                  v-slot:selection="{ text }" 
                )
                    v-chip(
                      small 
                      label 
                      color="primary"
                    ) {{ text }}
        v-flex(
          xs6 
          sm4 
          class="attachmentName" 
          v-else
        )
            span {{ getNameFile() }}
            v-btn(
              icon 
              color="red" 
              @click="deleteDocPendukungRincian('docPendukung')"
            )
                v-icon mdi-close
        v-flex(xs1 sm5)

    v-btn(class="mr-3" dark color='blue-grey' @click="backStep(1);scrollTop();") BACK
    v-btn(text class="mr-3" @click="backHome()") Cancel
    v-btn(color="primary" @click="nextStep(3); scrollTop();" :disabled='!isPageComplete') Continue
    //- v-btn(color="primary" @click="nextStep(3); scrollTop();" :disabled='') Continue
    
      
</template>

<script>
import { mapState } from "vuex";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { MyCustomUploadAdapterPlugin } from "../../utils/MyUploadAdapter";
import PemegangModal from "../PemegangModal.vue";
import axios from "axios";
export default {
  name: "KlasifikasiRincian",
  components: {
    PemegangModal
  },
  props: {
    e1: Number,
    dataSubmitPerubahan: Object,
    edit: { type: Boolean, default: false }
  },
  data() {
    return {
    editor: ClassicEditor,
    editorConfig: {
        extraPlugins: [MyCustomUploadAdapterPlugin],
        removePlugins: ["ImageUpload", "MediaEmbed"],
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'indent', 'outdent', '|', 'blockQuote', 'insertTable', 'undo', 'redo'],
        image: {
            // You need to configure the image toolbar, too, so it uses the new style buttons.
            toolbar: [
            "imageTextAlternative",
            "|",
            "imageStyle:alignLeft",
            "imageStyle:full",
            "imageStyle:alignRight",
            ],
            styles: [
            // This option is equal to a situation where no style is applied.
            "full",
            // This represents an image aligned to the left.
            "alignLeft",
            // This represents an image aligned to the right.
            "alignRight",
            ],
        },
    },
    rules: [
          value => !value || value.size < 10000000 || 'Ukuran file harus dibawah 10 MB!',
    ],
      docPendukungRincian: null
    };
  },
  mounted() {
    if ( this.$route.name == 'Izin Melaksanakan Usulan Perubahan' ) {
      this.getData();
    }
  },
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers"]),
    isPageComplete: function () {
      return (
        this.checkKlafisikasi(this.dataSubmitPerubahan.ipKlasifikasiUmum) > 0 &&
        this.checkValidData(this.dataSubmitPerubahan.ipRincianUsulan) &&
        this.checkValidData(this.dataSubmitPerubahan.ipHasilHarapan) &&
        !!this.dataSubmitPerubahan.ipHasilDescription 
      );
    }
  },
  methods: {
    checkKlafisikasi(data){
      const selectedData = data.filter(item => item.selected);
       return selectedData.length
    },
    checkValidData(data){
      let selectedData = data.filter(item => item.selected);
      let checkData = selectedData.length > 0 ? selectedData.every(item => item.selected && item.description) : false;
      return checkData
    },
    nextStep(val){
     this.$emit("continueBtn", val);
    },
    backStep(val){
     this.$emit("continueBtn", val);
    },
    backHome(){
      this.$router.push("/my-permit");
    },
    scrollTop(){
      window.scrollTo(0,0);
    },
    docName(name){
        return this.$setFilename(name);
      },
    deleteDocPendukungRincian(name){
      const id = this.dataSubmitPerubahan.ipHasilDescriptionUploadId;   
      this.$store
        .dispatch("deleteFile", {
            uploadId: id,
            folderName: name,
        })
        .then(() => {
          this.docPendukungRincian = null;
          this.dataSubmitPerubahan.ipHasilDescriptionUploadId = ""
          this.dataSubmitPerubahan.ipHasilDescriptionLampiran = {}
        })
        .catch(() => {
            this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    getData() {
      axios.get(`${this.API_URL}/v1/requests/perubahan/klasifikasi-umum`, 
        {
          headers: {"Authorization": `Bearer ${this.$store.state.token}`}
        }).then((res) => {
          const dataObj = res.data.data.questions.map(data => {
            return {
              label:data, 
              selected:false
            }
          })
          this.dataSubmitPerubahan.ipKlasifikasiUmum = dataObj
        });

      axios.get(`${this.API_URL}/v1/requests/perubahan/rincian-usulan`, 
        {
          headers: {"Authorization": `Bearer ${this.$store.state.token}`}
        }).then((res) => {
          const dataObj = res.data.data.questions.map(data => {
            return {
              label:data, 
              selected:false,
              description:""
            }
          })
          this.dataSubmitPerubahan.ipRincianUsulan = dataObj
        });

      axios.get(`${this.API_URL}/v1/requests/perubahan/hasil-diharapkan`, 
        {
          headers: {"Authorization": `Bearer ${this.$store.state.token}`}
        })
        .then((res) => {
          const dataObj = res.data.data.questions.map(data => {
            return {
              label:data, 
              selected:false,
              description:""
            }
          })
          this.dataSubmitPerubahan.ipHasilHarapan = dataObj
        });
    },
    getNameFile() {
      if ( this.docPendukungRincian ) {
        return this.docPendukungRincian.name
      } else {
        return this.docName(this.dataSubmitPerubahan.ipHasilDescriptionLampiran.docPendukung)
      }
    },
    handleSelectChange(item) {
      if ( !item.selected ) {
        item.description = ''
      } 
    },
  },
  watch: { 
    docPendukungRincian(params){
      if(params && params.size < 10000000){
        let formData = new FormData();
        formData.append('uploadId', Date.now() );
        formData.append('docPendukung', params );
        axios.post(`${this.API_URL}/v1/requests/attachment/docPendukung`, formData, {headers: {"Authorization": `Bearer ${this.$store.state.token}`}})
        .then(res =>{
          this.dataSubmitPerubahan.ipHasilDescriptionUploadId = res.data.uploadId
          this.dataSubmitPerubahan.ipHasilDescriptionLampiran.docPendukung = res.data.file.filename
        })
      }
    }
   },
};
</script>

<style></style>
